/**
 * 分录枚举 —— `transactions` / `legs` 的取值
 *
 * 依据：架构 §4.1 · 规格 §18（待缴状态流转）
 */

// ─────────────────────────── 腿方向 ───────────────────────────

/**
 * 腿方向（`legs.direction`）。
 *
 * 🔴 **账户余额恒等式**（架构 §4.1 / §5.4）：
 * `账户余额 = 初始余额 + Σin − Σout`（**同币种**；多币种不跨币种相加）
 *
 * ⚠️ 本枚举**只管方向**，不代表收入 / 支出 ——
 * 「是否计入收支」由 `excludeFromStats` + 唯一支出三段式口径决定（规格 §22.9）。
 */
export const LegDirection = {
  In: 'in',
  Out: 'out',
} as const;
export type LegDirection = (typeof LegDirection)[keyof typeof LegDirection];

// ─────────────────────────── 交易状态 ───────────────────────────

/**
 * 交易状态（`transactions.status`）。
 *
 * 用于**周期生成的待缴费用**（规格 §18 · `DR-010`）：
 * - 周期生成 → `Pending`（1 腿挂 `internal(payable)`、**计入收支**、UI 标「待缴·未付」）；
 * - 实际付款 → 生成转账 2 腿销账（**不计收支**）→ `Settled`。
 *
 * ⚠️ 与信用卡分期「不进流水」形成对照（分期不进是因为会**双计**；待缴进是因为它**别无旁证**）。
 */
export const TransactionStatus = {
  Pending: 'pending',
  Settled: 'settled',
} as const;
export type TransactionStatus = (typeof TransactionStatus)[keyof typeof TransactionStatus];
